import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { Language } from '../types';

interface LanguageState {
  currentLanguage: Language;
  setLanguage: (language: Language) => void;
  t: (key: string, enText: string, siText: string) => string;
}

const languages: Language[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'si', name: 'Sinhala', nativeName: 'සිංහල' }
];

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      currentLanguage: languages[1], // Default to Sinhala (සිංහල)
      setLanguage: (language: Language) => set({ currentLanguage: language }),
      t: (key: string, enText: string, siText: string) => {
        const { currentLanguage } = get();
        return currentLanguage.code === 'si' ? siText : enText;
      }
    }),
    {
      name: 'language-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export { languages };
